import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import awsmobile from '../aws-exports';  
import { get } from 'aws-amplify/api';
import './EmployeeDetails.css';

Amplify.configure(awsmobile);

// Function to capitalize the first letter of each word
function capitalize(str) {
  if (!str || typeof str !== 'string') return ''; // Check if the string is valid
  return str.charAt(0).toUpperCase() + str.slice(1);
}

// Function to format duration from milliseconds to hh:mm:ss
function formatDuration(ms) {
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}

function SpaceDetails() {
  const { id } = useParams();  // Get the space ID from the URL
  const [space, setSpace] = useState([]);
  const [spaceName, setSpaceName] = useState(null);
  const [totalDuration, setTotalDuration] = useState(0);
  const [totalBugDuration, setTotalBugDuration] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Function to fetch space details by ID
    const fetchSpaceById = async (id) => {
      try {
        const restOperation = get({
            apiName: 'spaces', 
            path: `/spaces/${id}`
        });
        const { body } = await restOperation.response; 
        const jsonResponse = await body.json();

        // Assuming jsonResponse is an object containing space_name and entries
        if (jsonResponse.entries.length > 0) {
          setSpaceName(jsonResponse.name); // Set space name
          setSpace(jsonResponse.entries);

          // Calculate total duration and total bug duration
          let total = 0;
          let totalBugs = 0;
          jsonResponse.entries.forEach(entry => {
            const duration = parseInt(entry.duration, 10);
            total += duration;

            if ([1001, 1010].includes(entry.task.custom_type)) {
              totalBugs += duration;
            }
          });

          setTotalDuration(total);
          setTotalBugDuration(totalBugs);
        } else {
          setError('No space entries found');
        }

        setLoading(false);
      } catch (err) {
        console.error('Fetching space failed:', err);
        setError('Failed to fetch space');
        setLoading(false);
      }
    };

    fetchSpaceById(id);
  }, [id]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;
  if (!spaceName) return <p>No space data found</p>;

  return (
    <div className="space-content">
      <h2>Space: {spaceName}</h2>
      <h3>Total Duration: {formatDuration(totalDuration)}</h3>
      <h3>Total Bug/Incident Duration: {formatDuration(totalBugDuration)}</h3>
      <h3>Entries Details</h3>
      <ul className="tasks-list">
        {space.map(entry => {
          let taskType = '';
          if (entry.task.custom_type === 1001) {
            taskType = 'Bug';
          } else if (entry.task.custom_type === 1010) {
            taskType = 'Incidence';
          }

          return (
            <li key={entry.id} className="task-item">
              <span className="title">{entry.task.name}</span><br/>
              <strong>Status:</strong> <span style={{ color: entry.task.status.color }}>{capitalize(entry.task.status.status)}</span><br/>
              <strong>Duration:</strong> {formatDuration(parseInt(entry.duration, 10))}<br/>
              {taskType && (
                <>
                  <strong>Type:</strong> {taskType}<br/>
                </>
              )}
              <a href={entry.task_url} target="_blank" rel="noopener noreferrer">View Task</a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default SpaceDetails;
